export const formData = {
  sectionA:{
    name:{
      label:'',
      data:'',
    },
    hospital_value_name:{
      label:'',
      data:'',
    },
    address:{
      label:'',
      data:'',
    },
    accredited:{
      label:'',
      data:'',
    },
    contact_name:{
      label:'',
      data:'',
    },
    contact_email:{
      label:'',
      data:'',
    },
    contact_phone:{
      label:'',
      data:'',
    },
    contact_ext:{
      label:'',
      data:'',
    },
    provider:{
      label:'',
      data:'',
    },
    provider_contact_name:{
      label:'',
      data:'',
    },
    provider_contact_email:{
      label:'',
      data:'',
    },
    provider_contact_phone:{
      label:'',
      data:'',
    },
    provider_contact_ext:{
      label:'',
      data:'',
    },
    crm_id:{
      label:'',
      data:'',
    },
    uci:{
      label:'',
      data:'',
    },
  },
}